import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Clock, ShieldCheck, FileText, Shield, MessageSquare, Wallet } from 'lucide-react';
const benefits = [{
  icon: Clock,
  title: 'Ne izgubljate časa z oglasi',
  description: 'Brez objavljanja, brez urejanja fotografij, brez nenehnega prenavljanja oglasov.'
}, {
  icon: MessageSquare,
  title: 'Brez klicev in pogajanj',
  description: 'Vso komunikacijo s kupci in pogajanja prevzamemo mi namesto vas.'
}, {
  icon: FileText,
  title: 'Pomagamo pri dokumentaciji',
  description: 'Uredimo vse papirje, prenos lastništva in administrativne formalnosti.'
}, {
  icon: ShieldCheck,
  title: 'Varnost',
  description: 'Sodelujemo le s preverjenimi kupci in zagotavljamo varno izvedbo transakcije.'
}, {
  icon: Shield,
  title: 'Transparenten postopek',
  description: 'Vedno veste, kaj se dogaja. Spremljate lahko celoten potek prodaje vašega vozila.'
}, {
  icon: Wallet,
  title: 'Denar hitro na računu',
  description: 'Varno in pravočasno nakazilo kupnine takoj po uspešni prodaji.'
}];
export function WhyAutopoint() {
  return <section className="py-16 md:py-24 bg-slate-50" data-id="element-341">
      <div className="container mx-auto px-4" data-id="element-342">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-343">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-344">
            Zakaj zaupati Autopointu?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-345">
            Prodaja vozila ne sme biti stresna. Mi poskrbimo za vse, vi pa mirno
            počakate na najboljšo ponudbo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-346">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-all hover:-translate-y-1" data-id="element-347">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-[#1EB6E8]/10 rounded-lg mb-4" data-id="element-348">
                <benefit.icon className="w-6 h-6 text-[#1EB6E8]" data-id="element-349" />
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-2" data-id="element-350">
                {benefit.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-351">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}